import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function OverrideAlert() {
    return (<Alert appearance="info" message={t({
            message: 'You are editing multiple templates with different signing parties',
            comment: 'Info message for editing default signatories for multiple templates with different signing parties',
        })}/>);
}
